import { render, staticRenderFns } from "./invoiceReceipt.vue?vue&type=template&id=0402f1dc&"
import script from "./invoiceReceipt.vue?vue&type=script&lang=js&"
export * from "./invoiceReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports